import type { OrganisationT } from "@/types/database/profiles";

import { ui } from "@/components/ui";

interface Props {
	onValueChange: (value: string) => void;
	organisations: OrganisationT[];
}

const SelectOrganisation = (props: Props) => {
	return (
		<ui.Select onValueChange={props.onValueChange}>
			<ui.SelectTrigger>
				<ui.SelectValue placeholder="Select Organisation" />
			</ui.SelectTrigger>
			<ui.SelectContent>
				{props.organisations?.map((organisation) => (
					<ui.SelectItem
						key={organisation.organisation_id}
						value={organisation.organisation_id}
					>
						{organisation.organisation_name}
					</ui.SelectItem>
				))}
			</ui.SelectContent>
		</ui.Select>
	);
};

export { SelectOrganisation };
